import React from 'react';
import { func, bool } from 'prop-types';

import FlatTab from 'ps-components/FlatTab/FlatTab';

import './ViewSwitcher.scss';

class ViewSwitcher extends React.Component {
  constructor(props) {
    super(props);
    this._showOverallComposites = this._showOverallComposites.bind(this);
    this._showSurveyJobMatches = this._showSurveyJobMatches.bind(this);
  }

  static propTypes = {
    showOverallCompositesAction: func,
    showSurveyJobMatches: func,
    showOverallComposites: bool
  };

  _showOverallComposites() {
    this.props.showOverallCompositesAction();
  }

  _showSurveyJobMatches() {
    this.props.showSurveyJobMatches();
  }

  render() {
    const { showOverallComposites } = this.props;

    return (
      <div className="yoy-view-switcher">
        <FlatTab
          className="yoy-view-switcher__tab"
          title="Overall Composite"
          tabClick={this._showOverallComposites}
          selected={showOverallComposites}
          selectedClassName="yoy-view-switcher__selected-tab"
        />
        <FlatTab
          className="yoy-view-switcher__tab"
          title="Survey Job Matches"
          tabClick={this._showSurveyJobMatches}
          selected={!showOverallComposites}
          selectedClassName="yoy-view-switcher__selected-tab"
        />
      </div>
    );
    /*
      static propTypes = {
        title: PropTypes.string,
        tabClick: PropTypes.func,
        selected: PropTypes.bool,
        className: PropTypes.string,
        selectedClassName: PropTypes.string,
        isDisabled: PropTypes.bool
      };
    */
  }
}

export default ViewSwitcher;
